import { css } from 'styled-components';
import { darken, lighten, parseToHsl } from 'polished';
import memoize from 'lodash.memoize';
import { HexToCssConfiguration, hexToCSSFilter } from 'hex-to-css-filter';

export const useGreyscaleCss = (colour?: string, alpha: number = 1) => css`
  filter: ${colour ? `saturate(0%) brightness(0%) invert(${parseToHsl(colour).lightness}) opacity(${alpha})` : `grayscale(calc(100% * ${alpha}))`};
`;

let useFilterColourCssDisabled = false;
export const disableUseFilterColourCss = () => (useFilterColourCssDisabled = true);

export const useFilterColourCss = memoize((colour?: string, alpha: number = 1, filterOptions?: HexToCssConfiguration) => {
  if (!colour || useFilterColourCssDisabled) {
    return ``;
  }

  const cssFilter = hexToCSSFilter(colour, filterOptions ?? { forceFilterRecalculation: false })?.filter;

  return css`
    // grayscale fallback if SVG from data url is not supported
    ${useGreyscaleCss(colour, alpha)};
    ${cssFilter &&
    css`
      filter: ${cssFilter};
    `};
  `;
});

export const adjustRgbColour = (colour: string, percentage: number = 10, lightenColour?: boolean) => {
  const polishedPercentage = percentage / 100 / 2; // polished seems to divide the percentage to 2
  return lightenColour ? lighten(polishedPercentage, colour) : darken(polishedPercentage, colour);
};
